angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        //Creates an default titleMap list from an enum, i.e. a list of strings.
        var enumToTitleMap = function(enm) {
            var titleMap = []; //canonical titleMap format is a list.
            enm.forEach(function(name) {
                titleMap.push({name: name, value: name});
            });
            return titleMap;
        };

        var stripNullType = function(type) {
            if (Array.isArray(type) && type.length == 2) {
                if (type[0] === 'null')
                    return type[1];
                if (type[1] === 'null')
                    return type[0];
            }
            return type;
        };

        var checkbox = function(name, schema, options) {
            if (stripNullType(schema.type) === 'boolean') {
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'checkbox';
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        // Add our default to the defaults array
        angular.forEach(schemaFormProvider.defaults.boolean, function(value, i){
            if (value.name == 'checkbox') {
                schemaFormProvider.defaults.boolean[i] = checkbox;
            }
        });

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'checkbox',
            'app/schema-form-component/angular-schema-form-checkbox/angular-schema-form-checkbox.html');

    }]);
